import { create } from 'zustand'
import { THEME_COLOR_STORAGE_KEY, THEME_STORAGE_KEY } from '@/const/theme-storage.ts'
import { isThemeColor, PRIMARY_COLOR } from '@/const/theme.ts'

export type ThemeMode = 'light' | 'dark' | 'system'

type ThemeStore = {
  mode: ThemeMode
  primaryColor: string
  setPrimaryColor: (color: string) => void
  setMode: (mode: ThemeMode) => void
}

function isThemeMode(value: string | null): value is ThemeMode {
  return value === 'light' || value === 'dark' || value === 'system'
}

function readStoredTheme(): ThemeMode {
  if (typeof window === 'undefined') {
    return 'system'
  }

  try {
    const storedTheme = window.localStorage.getItem(THEME_STORAGE_KEY)
    return isThemeMode(storedTheme) ? storedTheme : 'system'
  } catch {
    return 'system'
  }
}

function readStoredColor(): string {
  try {
    const color = window.localStorage.getItem(THEME_COLOR_STORAGE_KEY)
    return isThemeColor(color) ? color : PRIMARY_COLOR
  } catch {
    return PRIMARY_COLOR
  }
}

export const useThemeStore = create<ThemeStore>((set) => ({
  mode: readStoredTheme(),
  primaryColor: readStoredColor(),
  setPrimaryColor: (color) => {
    if (!isThemeColor(color)) return
    set({ primaryColor: color })
    try {
      window.localStorage.setItem(THEME_COLOR_STORAGE_KEY, color)
    } catch {
      // 存储不可用时，主题仍在当前页面生命周期内生效。
    }
  },
  setMode: (mode) => {
    set({ mode })

    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, mode)
    } catch {
      // 存储不可用时，主题仍在当前页面生命周期内生效。
    }
  }
}))

export { THEME_STORAGE_KEY } from '@/const/theme-storage.ts'
